import { LEDGER_PAGE_SIZE } from "./constants";
import {
  acorn_transaction,
  and,
  asc,
  daily_reward_claim,
  desc,
  eq,
  type PowerSyncDrizzleDB,
  redemption,
  shop_product,
  wallet,
} from "@famidex/powersync";

/**
 * ECONOMÍA de Bellotas — lecturas del cliente. El wallet, el ledger, los canjes y
 * las reclamaciones diarias llegan por el stream PRIVADO `my_wallet` (aislado por
 * usuario); la tienda por el stream PÚBLICO `shop_catalog`. Son proyecciones
 * READ-ONLY: el cliente NUNCA escribe estas tablas (el saldo lo muta sólo el
 * servidor por REST /api/economy/*). Sin papelera (no son datos borrables).
 */

/** Wallet (saldo autoritativo) del usuario. Una fila como mucho. */
export function getWalletQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db.select().from(wallet).where(eq(wallet.user_id, userId)).limit(1);
}

/** Ledger de transacciones del usuario, más reciente primero. */
export function getAcornTransactionsQuery(
  db: PowerSyncDrizzleDB,
  userId: string,
  limit = LEDGER_PAGE_SIZE,
) {
  return db
    .select()
    .from(acorn_transaction)
    .where(eq(acorn_transaction.user_id, userId))
    .orderBy(desc(acorn_transaction.created_at))
    .limit(limit);
}

/** Tienda: productos activos, opcionalmente filtrados por familia (pack/frame/sticker). */
export function getShopProductsQuery(db: PowerSyncDrizzleDB, opts?: { kind?: string }) {
  const base = db.select().from(shop_product).where(eq(shop_product.is_active, 1));
  const filtered = opts?.kind
    ? db
        .select()
        .from(shop_product)
        .where(and(eq(shop_product.is_active, 1), eq(shop_product.kind, opts.kind)))
    : base;
  return filtered.orderBy(asc(shop_product.sort_order));
}

/** Canjes del usuario (marcos/stickers obtenidos con bellotas). */
export function getRedemptionsQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select()
    .from(redemption)
    .where(eq(redemption.user_id, userId))
    .orderBy(desc(redemption.created_at));
}

/** Reclamaciones de la recompensa diaria del usuario, más reciente primero. */
export function getDailyRewardClaimsQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select()
    .from(daily_reward_claim)
    .where(eq(daily_reward_claim.user_id, userId))
    .orderBy(desc(daily_reward_claim.claimed_on));
}
